/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { SampleWriteUrls } from './SampleWriteUrls';
import { SampleWriteUrlsFromJSON, SampleWriteUrlsFromJSONTyped, SampleWriteUrlsToJSON, } from './SampleWriteUrls';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface CreateSampleWithWriteUrlsResponse
 *
 */
// create custom validators for the regexes
typia.customValidators.insert("pattern_CreateSampleWithWriteUrlsResponse_id")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
export interface CreateSampleWithWriteUrlsResponse {
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof CreateSampleWithWriteUrlsResponse
        
        
    * @pattern_CreateSampleWithWriteUrlsResponse_id
         */
    id: string;
    /**
     *
     * #type SampleWriteUrls
     * #memberof CreateSampleWithWriteUrlsResponse
        
        
         */
    sampleWriteUrls: SampleWriteUrls;
}
/**
 * Check if a given object implements the CreateSampleWithWriteUrlsResponse interface.
 */
export function instanceOfCreateSampleWithWriteUrlsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "sampleWriteUrls" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { SampleWriteUrlsValidator, SampleWriteUrlsStringifyShape, SampleWriteUrlsStringifyShapeProperties, } from './SampleWriteUrls';
export const CreateSampleWithWriteUrlsResponseTypiaAssertEquals = (input: any) => {
    return ((input: any): CreateSampleWithWriteUrlsResponse => {
        const __is = (input: any, _exceptionable: boolean = true): input is CreateSampleWithWriteUrlsResponse => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.id && $is_custom("pattern_CreateSampleWithWriteUrlsResponse_id", "string", "", input.id) && ("object" === typeof input.sampleWriteUrls && null !== input.sampleWriteUrls && $io1(input.sampleWriteUrls, true && _exceptionable)) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["id", "sampleWriteUrls"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.full && "string" === typeof input.thumb && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["full", "thumb"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateSampleWithWriteUrlsResponse => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_CreateSampleWithWriteUrlsResponse_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_CreateSampleWithWriteUrlsResponse_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && (("object" === typeof input.sampleWriteUrls && null !== input.sampleWriteUrls || $guard(_exceptionable, {
                    path: _path + ".sampleWriteUrls",
                    expected: "SampleWriteUrls",
                    value: input.sampleWriteUrls
                })) && $ao1(input.sampleWriteUrls, _path + ".sampleWriteUrls", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".sampleWriteUrls",
                    expected: "SampleWriteUrls",
                    value: input.sampleWriteUrls
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["id", "sampleWriteUrls"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.full || $guard(_exceptionable, {
                    path: _path + ".full",
                    expected: "string",
                    value: input.full
                })) && ("string" === typeof input.thumb || $guard(_exceptionable, {
                    path: _path + ".thumb",
                    expected: "string",
                    value: input.thumb
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["full", "thumb"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "CreateSampleWithWriteUrlsResponse",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "CreateSampleWithWriteUrlsResponse",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const CreateSampleWithWriteUrlsResponseTypiaAssertStringify = (input: CreateSampleWithWriteUrlsResponse): string => {
    return ((input: any): string => { const assert = (input: any): CreateSampleWithWriteUrlsResponse => {
        const __is = (input: any): input is CreateSampleWithWriteUrlsResponse => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).id && $is_custom("pattern_CreateSampleWithWriteUrlsResponse_id", "string", "", (input as any).id) && ("object" === typeof (input as any).sampleWriteUrls && null !== (input as any).sampleWriteUrls && ("string" === typeof ((input as any).sampleWriteUrls as any).full && "string" === typeof ((input as any).sampleWriteUrls as any).thumb)));
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateSampleWithWriteUrlsResponse => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_CreateSampleWithWriteUrlsResponse_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_CreateSampleWithWriteUrlsResponse_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && (("object" === typeof input.sampleWriteUrls && null !== input.sampleWriteUrls || $guard(_exceptionable, {
                    path: _path + ".sampleWriteUrls",
                    expected: "SampleWriteUrls",
                    value: input.sampleWriteUrls
                })) && $ao1(input.sampleWriteUrls, _path + ".sampleWriteUrls", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".sampleWriteUrls",
                    expected: "SampleWriteUrls",
                    value: input.sampleWriteUrls
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.full || $guard(_exceptionable, {
                    path: _path + ".full",
                    expected: "string",
                    value: input.full
                })) && ("string" === typeof input.thumb || $guard(_exceptionable, {
                    path: _path + ".thumb",
                    expected: "string",
                    value: input.thumb
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "CreateSampleWithWriteUrlsResponse",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "CreateSampleWithWriteUrlsResponse",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: CreateSampleWithWriteUrlsResponse): string => {
        const $io1 = (input: any): boolean => "string" === typeof input.full && "string" === typeof input.thumb;
        const $string = (typia.createAssertStringify as any).string;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        return `{"id":${$string((input as any).id)},"sampleWriteUrls":${`{"full":${$string(((input as any).sampleWriteUrls as any).full)},"thumb":${$string(((input as any).sampleWriteUrls as any).thumb)}}`}}`;
    }; return stringify(assert(input)); })(input);
};
export const CreateSampleWithWriteUrlsResponseValidatorShape = {
    'id': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'sampleWriteUrls': SampleWriteUrlsValidator.defined(),
};
export const CreateSampleWithWriteUrlsResponseValidator = yup.object().shape(CreateSampleWithWriteUrlsResponseValidatorShape);
export const CreateSampleWithWriteUrlsResponseStringifyShapeProperties: ObjectSchema['properties'] = {
    'id': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'sampleWriteUrls': SampleWriteUrlsStringifyShape,
};
export const CreateSampleWithWriteUrlsResponseStringifyShape: ObjectSchema = {
    title: 'CreateSampleWithWriteUrlsResponse Stringifier',
    type: 'object',
    properties: {
        ...CreateSampleWithWriteUrlsResponseStringifyShapeProperties
    },
    required: [
        'id',
        'sampleWriteUrls',
    ],
};
export const CreateSampleWithWriteUrlsResponseStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(CreateSampleWithWriteUrlsResponseStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const CreateSampleWithWriteUrlsResponseStringify: (data: CreateSampleWithWriteUrlsResponse) => string = CreateSampleWithWriteUrlsResponseStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function CreateSampleWithWriteUrlsResponseFromJSON(json: any): CreateSampleWithWriteUrlsResponse {
    return CreateSampleWithWriteUrlsResponseFromJSONTyped(json, false);
}
export function CreateSampleWithWriteUrlsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSampleWithWriteUrlsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'id': json['id'],
        'sampleWriteUrls': SampleWriteUrlsFromJSON(json['sampleWriteUrls']),
    };
}
export function CreateSampleWithWriteUrlsResponseToJSON(value?: CreateSampleWithWriteUrlsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'sampleWriteUrls': SampleWriteUrlsToJSON(value.sampleWriteUrls),
    };
}
